import React from "react";
import { Toaster as SonnerToaster, toast } from "sonner";

export const ToasterRoot = () => (
	<SonnerToaster richColors closeButton position="bottom-right" />
);

export type ToastType = "success" | "error" | "info" | "warning" | "loading" | "default";

export function toaster(type: ToastType | string, message: React.ReactNode, opts?: any) {
	const t = String(type || "").toLowerCase();
	const options = {
		position: "bottom-right" as const,
		style: {
			borderWidth: "1px",
			borderStyle: "solid",
			fontSize: "1rem",
		},
		...opts,
	}

	switch (t) {
		case "success":
			return toast.success(message, {
				style: {
					backgroundColor: "var(--success-bg)",
					color: "var(--success-text)",
					borderColor: "var(--success-border)",
				},
				...options
			});
		case "error":
			return toast.error(message, {
				style: {
					backgroundColor: "var(--error-bg)",
					color: "var(--error-text)",
					borderColor: "var(--error-border)",
				},
				...options
			});
		case "info":
			return toast.info(message, {
				style: {
					backgroundColor: "var(--info-bg)",
					color: "var(--info-text)",
					borderColor: "var(--info-border)",
				},
				...options
			});
		case "warning":
			return (toast as any).warning ? (toast as any).warning(message, {
				style: {
					backgroundColor: "var(--warning-bg)",
					color: "var(--warning-text)",
					borderColor: "var(--warning-border)",
				},
				...options
			}) : toast(message, { ...options, type: "warning" });
		case "loading":
			return toast.loading(message, {
				style: {
					backgroundColor: "var(--warning-bg)",
					color: "var(--warning-text)",
					borderColor: "var(--warning-border)",
				},
				...options
			});
		default:
			return toast(message, {
				style: {
					backgroundColor: "var(--normal-bg)",
					color: "var(--normal-text)",
					borderColor: "var(--normal-border)",
				},
				...options
			});
	}
}

export default ToasterRoot;
